import * as THREE from "three"
import { EventDispatcher } from "three"
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js"
import { FBXLoader } from "three/examples/jsm/loaders/FBXLoader.js"


export default class Resources extends EventDispatcher{
    constructor(sources){
        super()
        //console.log("Resources Class")
        // Options
        this.sources = sources
        
        //setup
        this.items = {}
        this.toLoad = this.sources.length
        this.loaded = 0

        //console.log("this is how many sources there are to load")
        //console.log(this.toLoad)

        this.readyEvent = new Event("ready")

        this.setLoaders()
        this.startLoading()
    }

    setLoaders(){
        this.loaders = {}
        this.loaders.gltfLoader = new GLTFLoader() // This is not needed
        this.loaders.fbxLoader = new FBXLoader()
        this.loaders.textureLoader = new THREE.TextureLoader()
        this.loaders.cubeTextureLoader = new THREE.CubeTextureLoader()
    }

    async startLoading(){
        for (const source of this.sources){
            await this.loadingSingle(source)
        }
    }

    loadingSingle(source){
        return new Promise((resolve, reject) =>{
            const onLoad = (file) => {
                this.sourceLoaded(source, file)
                resolve()
            }

            const onError = (e) => {
                console.warn(`${source.name} failed to load`, e)
                reject(e)
            }
            if(source.type === "fbx"){
                this.loaders.fbxLoader.load(source.path, onLoad, null, onError)
            }
            else if (source.type === "gltfModel"){
                this.loaders.gltfLoader.load(source.path, onLoad, null, onError)
            }
            else if (source.type === "texture"){
                this.loaders.textureLoader.load(source.path, onLoad, null, onError)
            }
            else if (source.type === "cubeTexture"){
                this.loaders.cubeTextureLoader.load(source.path, onLoad, null, onError)
            }
            else{
                reject("Unknown Resource Type")
            }
        })
    }

    startLoadingOld(){
        for(const source of this.sources){
            //console.log(source)
            if(source.type === "fbx"){
                this.loaders.fbxLoader.load(
                    source.path,
                    (file) => {
                        this.sourceLoaded(source, file)
                    },
                    () =>{
                        console.log("loading fbx file")
                    },
                    (e) =>{
                        console.log("fbx error")
                        console.log(e)
                    }
                )
            }
            else if(source.type === "gltfModel"){
                this.loaders.gltfLoader.load(
                    source.path,
                    (file) => {
                        //console.log(file)
                        this.sourceLoaded(source, file)
                    },
                    () =>{
                        console.log("loading gltf file")
                    },
                    (e) =>{
                        console.log("gltf error")
                        console.log(e)
                    }
                )
            }
            else if(source.type === "texture"){
                this.loaders.textureLoader.load(
                    source.path,
                    (file) =>{
                        //console.log(source, file)
                        this.sourceLoaded(source, file)
                    },
                    ()=>{
                        console.log("loading texture file")
                    },
                    (e) =>{
                        console.log("texture error")
                        console.log(e)
                    }
                )
            }
            else if(source.type === "cubeTexture"){
                this.loaders.cubeTextureLoader.load(
                    source.path,
                    (file) =>{
                        //console.log(source, file)
                        this.sourceLoaded(source, file)
                    },
                    ()=>{
                        console.log("loading cube texture file")
                    },
                    (e) =>{
                        console.log("cube texture error")
                        console.log(e)
                    }
                )
            }
        }
    }

    sourceLoaded(source, file){
        //console.log("SourceLoaded is running")
        this.items[source.name] = file
        this.loaded++
        //console.log(this.toLoad)
        //console.log(this.loaded)
        //console.log(source.name)
        if(this.loaded === this.toLoad){
            //console.log("all resources loaded")
            this.dispatchEvent({
                type: 'ready',
                message: 'dispatch ready event'
            })
        }
    }
}